var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.6667 26.6666H10V8.33325H26.6667V13.3333H31.6667L36.6667 21.6666V26.6666Z",
    fill: "#015BBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.9167C31.1483 27.9167 32.0833 28.8517 32.0833 30C32.0833 31.1483 31.1483 32.0833 30 32.0833C28.8517 32.0833 27.9167 31.1483 27.9167 30C27.9167 28.8517 28.8517 27.9167 30 27.9167ZM30 25C27.2383 25 25 27.2383 25 30C25 32.7617 27.2383 35 30 35C32.7617 35 35 32.7617 35 30C35 27.2383 32.7617 25 30 25ZM10 27.9167C11.1483 27.9167 12.0833 28.8517 12.0833 30C12.0833 31.1483 11.1483 32.0833 10 32.0833C8.85167 32.0833 7.91667 31.1483 7.91667 30C7.91667 28.8517 8.85167 27.9167 10 27.9167ZM10 25C7.23833 25 5 27.2383 5 30C5 32.7617 7.23833 35 10 35C12.7617 35 15 32.7617 15 30C15 27.2383 12.7617 25 10 25Z",
    fill: "#015BBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3334 29.9999H33.3334V26.6666H35V22.4533L31.2734 14.9999H25V11.6666H31.2734C32.5367 11.6666 33.69 12.3799 34.255 13.5099L38.3334 21.6666V29.9999ZM13.3334 26.6666H26.6667V29.9999H13.3334V26.6666ZM10 16.6666H13.3334V21.6666H10V16.6666ZM10 8.33325H13.3334V13.3333H10V8.33325ZM1.66669 16.6666H5.00002V21.6666H1.66669V16.6666Z",
    fill: "#015BBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 8.33325V11.6666H23.3333V26.6666H26.6666V8.33325H11.6666Z",
    fill: "#015BBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 8.33325V13.3333H5.00002V11.6666H6.66669V8.33325H1.66669ZM5.00002 24.9999H1.66669V29.9999H6.66669V26.6666H5.00002V24.9999Z",
    fill: "#015BBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.f3a88e885b418a524ed94b21aad9a350.svg";
export { ForwardRef as ReactComponent };